import { createSelector } from 'reselect'
import { EnergyMix, Filiere, FiliereFilters } from '../types'
import { selectEnergyMixCurrentTerritory } from './TreeMap'

export const selectEnabledFilieres = createSelector(
    selectEnergyMixCurrentTerritory,
    (energyMix: EnergyMix): FiliereFilters => {
        const filieresEnabled: FiliereFilters = []
        Object.entries(energyMix).forEach(([filiere, puissance]) => {
            if (puissance) {
                filieresEnabled.push(filiere as Filiere)
            }
        })
        return filieresEnabled
    }
)
